export { default as AdLink } from './AdLink';



// WEBPACK FOOTER //
// ./src/components/SimilarAdCard/AdLink/index.ts